import { render, staticRenderFns } from "./GoogleDriveWorkspaceModal.vue?vue&type=template&id=0a0623c4&"
import script from "./GoogleDriveWorkspaceModal.vue?vue&type=script&lang=js&"
export * from "./GoogleDriveWorkspaceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GoogleDriveWorkspaceModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GoogleDriveWorkspaceModal.vue
// module id = 2280
// module chunks = 1